import { render, staticRenderFns } from "./Crud.vue?vue&type=template&id=6dfac605&"
import script from "./Crud.vue?vue&type=script&lang=js&"
export * from "./Crud.vue?vue&type=script&lang=js&"
import style0 from "./Crud.vue?vue&type=style&index=0&id=6dfac605&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports